module.exports = __webpack_public_path__ + "img/social-5.37794fc3.jpg";